module.exports = __webpack_public_path__ + "img/preferences.bed68b09.jpg";